/* PureState ingredient tiles (sections/ps-ingredient-tiles.liquid): the "Mai mult" toggle.
   One delegated listener per page, guarded so a section re-render in the theme editor cannot double-bind.
   No Romanian literals: the button label comes from the section settings. */
(function () {
  'use strict';
  if (window.__psIngredientTiles) return;
  window.__psIngredientTiles = true;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.ps-it__more');
    if (!btn) return;
    var id = btn.getAttribute('aria-controls');
    var panel = id ? document.getElementById(id) : null;
    if (!panel) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    panel.hidden = open;
  });
})();
